export enum GraphScaleKinds {
  Individual = 1,
  Common = 2,
}
